import React from 'react';

function Footer() {
  const ano = new Date().getFullYear();

  return (
    <section id="contato">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div id="carouselExampleFade" className="carousel slide carousel-fade" data-bs-ride="carousel">
              <div className="carousel-inner">
                <div className="carousel-item active" data-bs-interval="3000">
                  <a href="https://bit.ly/3Pynts7" target="_blank" rel="noopener noreferrer">
                    <img src="/Images/Parceiros/Banner-renda-extra-hotmart.png" className="zoom-img" />
                  </a>
                </div>
                <div className="carousel-item" data-bs-interval="3000">
                  <a href="https://bit.ly/3pOcj5d" target="_blank" rel="noopener noreferrer">
                    <img src="/Images/Parceiros/Vargas-banner-Lado-B.png" className="zoom-img" />
                  </a>
                </div>
                <div className="carousel-item" data-bs-interval="3000">
                  <a href="http://bit.ly/3UN1KNb" target="_blank" rel="noopener noreferrer">
                    <img src="/Images/Parceiros/Vargas-banner-Lado-A.png" className="zoom-img" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Logo e redes sociais */}
      <div className="container">
        <div className="row text-center my-4">
          <div className="col-lg-4" />
          <div className="col-lg-4">
            <img src="/Images/Logo-WCONTEC.P.png" alt="Logo Wcontec" />
          </div>
          <div className="col-lg-4" />
        </div>

        <div className="text-center">
          <ul className="list-unstyled list-inline social">
            <li className="list-inline-item zoom-img">
              <a href="https://t.me/+bLsp1DsfZOo2M2Ix" target="_blank" rel="noopener noreferrer"><i className="fab fa-telegram fa-2x"></i></a>
            </li>
            <li className="list-inline-item zoom-img">
              <a href="https://instagram.com/wcontec?r=nametag" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram fa-2x"></i></a>
            </li>
            <li className="list-inline-item zoom-img">
              <a href="https://youtube.com/@wcontec2017" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube fa-2x"></i></a>
            </li>
            <li className="list-inline-item zoom-img">
              <a href="https://twitter.com/w_contec" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter fa-2x"></i></a>
            </li>
            <li className="list-inline-item zoom-img">
              <a href="https://chat.whatsapp.com/Co4DkBgkhrr6XSDiRL3CBP" target="_blank" rel="noopener noreferrer"><i className="fab fa-whatsapp fa-2x"></i></a>
            </li>
          </ul>
        </div>
      </div>

      {/* Termos e política de privacidade */}
      <div className="container-fluid" id="termos">
        <div className="row termodeuso">
          <p className="text-center">
            <a className="termos-a" data-bs-toggle="collapse" href="#termos-de-uso-e-privacidade" role="button" aria-expanded="false" aria-controls="termos-de-uso-e-privacidade">
              Termos de Uso e Política de Privacidade - 
            </a>
            Copyright © {ano} Wcont Serviços Contábeis. Todos os direitos reservados.
          </p>

          <div className="collapse" id="termos-de-uso-e-privacidade">
            <div className="p-4">
              <h6><li className="sbAccessibliltyFontSize">Termos de Uso</li></h6>
              <p>Este site pertence à Wcont Serviços Contábeis. A reprodução, distribuição ou modificação de qualquer conteúdo é proibida sem autorização expressa. O uso das informações aqui contidas é por sua conta e risco.</p>
              <p>Links para sites de parceiros são disponibilizados, mas a Wcont não se responsabiliza pelo conteúdo, práticas, obrigações legais ou qualquer atividade exercida por parceiros. O suporte técnico oferecido se limita à publicação e manutenção de imagens e textos autorizados.</p>

              <h6><li className="sbAccessibliltyFontSize">Política de Privacidade</li></h6>
              <p>Coletamos dados pessoais como nome, CPF, endereço, e-mail, telefone e dados de acesso à plataforma para prestação de serviços contábeis e uso do sistema online.</p>
              <p>Esses dados são utilizados apenas conforme previsto em lei, para fins legítimos e nunca são vendidos a terceiros. O usuário tem direito de acessar, corrigir, portar ou excluir suas informações, mediante solicitação via e-mail.</p>
              <p>Em caso de dúvidas ou solicitações relacionadas à privacidade, entre em contato via <a href="mailto:contato@wcontec.com.br">contato@wcontec.com.br</a>.</p>

              <p className="mt-3 text-end">
                <i className="fa fa-arrow-up" aria-hidden="true"></i> <a className="termos-a" data-bs-toggle="collapse" href="#termos-de-uso-e-privacidade" role="button">Voltar</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Footer;
